// extracted by mini-css-extract-plugin
module.exports = {"pageButtonSlider":"styles_pageButtonSlider__Rom95","pageButtonSliderDot":"styles_pageButtonSliderDot__DF7mW"};